/**
 * Ticket 89 — same alert copy as backend payrollAttendanceMutualGate (≤ 2 sentences).
 * Keep wording in sync with backend/src/utils/payrollAttendanceMutualGate.js
 */

const MONTH_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function formatPayMonthShort(ym) {
  const m = String(ym || "").match(/^(\d{4})-(\d{2})$/);
  if (!m) return String(ym || "");
  const monthIdx = Number(m[2]) - 1;
  if (monthIdx < 0 || monthIdx > 11) return String(ym);
  return `${MONTH_SHORT[monthIdx]} ${m[1]}`;
}

function payrollStatusPhrase(finalized, processedCount) {
  const n = Number(processedCount) || 0;
  if (finalized && n > 0) {
    return n === 1
      ? "finalised and 1 employee is processed"
      : `finalised and ${n} employees are processed`;
  }
  if (finalized) return "finalised";
  if (n === 1) return "already processed for 1 employee";
  if (n > 1) return `already processed for ${n} employees`;
  return "in progress";
}

export function messageAttendanceNotFinalised(payMonth) {
  const label = formatPayMonthShort(payMonth);
  return (
    `Attendance for ${label} is not finalised yet. ` +
    `Finalise attendance for this month before Process Payroll.`
  );
}

export function messageUnlockBlockedByPayroll(payMonth, { finalized, processedCount }) {
  const label = formatPayMonthShort(payMonth);
  const status = payrollStatusPhrase(finalized, processedCount);
  const nextStep = finalized
    ? "Unprocess and unfinalise payroll for this month first, then unlock attendance."
    : "Unprocess payroll for this month first, then unlock attendance.";
  return `Cannot unlock attendance for ${label} — payroll is ${status}. ${nextStep}`;
}

export function messageEditDespitePayrollProgress(payMonth, { finalized, processedCount }) {
  const label = formatPayMonthShort(payMonth);
  const status = payrollStatusPhrase(finalized, processedCount);
  return (
    `Payroll for ${label} is ${status}. ` +
    `Editing attendance now may not match payroll — continue anyway?`
  );
}
